/* custom js here */
document.addEventListener("cart:change", (event) => {
    //fetchCart = event.detail["cart"];
      console.log("changed!");
      var exist_gift = false;
      setTimeout(function() {
          $(".line-item").each(function() {
              var $text = $(this).find(".line-item__info .v-stack a span").text();
              //console.log($text);
              if($text == "SAC CADEAU POUR OFFRIR") {
                  $(".cart-drawer__recommendations").hide();
                  exist_gift = true;
                  return false; // breaks
              }
              if(exist_gift == false) {
                  $(".cart-drawer__recommendations").show();
              }
          });
      }, 500)
  });

// document.addEventListener('variant:change', (event) => {
//     const mediaId = event?.detail?.variant?.featured_media?.id;
//     if(mediaId){
//         document.querySelectorAll('.variant-images').forEach((element)=>{
//             const mid = element.getAttribute('media-id');
//             if(mid !== mediaId.toString()) element.classList.add('display-none')
//             else element.classList.remove('display-none')
//         })
//     }
//     console.log('should be first')
// })